// Базовые константы меню
export const MainMenu = {
    // лимит на добавление элементов в избранное
    FAVORITE_ITEMS_LIMIT: 5,
};
